import React from 'react';
import ReactDOM from 'react-dom';
import { unregister } from './registerServiceWorker';

import './index.css';
import './c3jscustom.css';

import App from './App';
import { initializeFirebase } from './pages/users/UserFeedPage';

unregister();

ReactDOM.render(<App />, document.getElementById('root'));
initializeFirebase();
